import {
  DOWNLOAD_PORTABILITY_ERROR,
  DOWNLOAD_PORTABILITY_SFTP,
  DOWNLOAD_PORTABILITY_STORAGE,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

export const downloadPortabilityFileStorageAction = (date) => async (dispatch) => {
  const url = `/api/ipb/report/portability/storage?date_time=${date}`;

  try {
    const response = await axiosTokenInstance.get(url, {
      responseType: 'blob',
    });

    // Extraer nombre de archivo del header si está disponible
    const contentDisposition = response.headers['content-disposition'];
    let filename = `archivo_${date}`;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    const blob = new Blob([response.data]);
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    dispatch({
      method: 'get',
      payload: {
        success: true,
        filename,
        date,
      },
      status: response.status,
      type: DOWNLOAD_PORTABILITY_STORAGE,
    });
  } catch (e) {
    let errorMessage = 'Error desconocido';
    let errorPayload = {};

    if (e.response && e.response.data instanceof Blob) {
      try {
        // Convertir el blob a texto
        const errorText = await e.response.data.text();

        // Intentar parsearlo como JSON (porque tu backend lo envía así)
        try {
          const parsed = JSON.parse(errorText);
          errorPayload = parsed;
          errorMessage = parsed.message || JSON.stringify(parsed);
        } catch {
          // Si no es JSON válido, usar texto como está
          errorMessage = errorText;
        }
      } catch {
        errorMessage = 'No se pudo leer el mensaje de error';
      }
    } else {
      errorMessage = e.message || 'Error de red o desconocido';
      errorPayload = e;
    }

    dispatch({
      method: 'get',
      payload: {
        message: errorMessage,
        ...errorPayload,
      },
      status: e?.response?.status || null,
      type: DOWNLOAD_PORTABILITY_ERROR,
    });

    throw errorMessage;
  }
};

export const downloadPortabilityFileSFTPAction = (date, downloadSource) => async (dispatch) => {
  const url = `/api${downloadSource === 'ipb' ? '/ipb' : ''}/report/portability/sftp?date_time=${date}`;

  try {
    const response = await axiosTokenInstance.get(url, {
      responseType: 'blob',
    });

    // Extraer el nombre del archivo si viene en los headers
    const contentDisposition = response.headers['content-disposition'];
    let filename = `sftp_${date}`;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    const blob = new Blob([response.data]);
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);

    dispatch({
      method: 'get',
      payload: {
        success: true,
        filename,
        date,
      },
      status: response.status,
      type: DOWNLOAD_PORTABILITY_SFTP,
    });
  } catch (e) {
    let errorMessage = 'Error desconocido';
    let errorPayload = {};

    if (e.response && e.response.data instanceof Blob) {
      try {
        // Convertir el blob a texto
        const errorText = await e.response.data.text();

        // Intentar parsearlo como JSON (porque tu backend lo envía así)
        try {
          const parsed = JSON.parse(errorText);
          errorPayload = parsed;
          errorMessage = parsed.message || JSON.stringify(parsed);
        } catch {
          // Si no es JSON válido, usar texto como está
          errorMessage = errorText;
        }
      } catch {
        errorMessage = 'No se pudo leer el mensaje de error';
      }
    } else {
      errorMessage = e.message || 'Error de red o desconocido';
      errorPayload = e;
    }

    dispatch({
      method: 'get',
      payload: {
        message: errorMessage,
        ...errorPayload,
      },
      status: e?.response?.status || null,
      type: DOWNLOAD_PORTABILITY_ERROR,
    });

    throw errorMessage;
  }
};
